export const emailValidator = {
  pattern:
    "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$",
  onInvalid: (e: any) => {
    e.target.setCustomValidity("");
    if (!e.target.validity.valid) {
      e.target.setCustomValidity("Please enter the correct email address");
    }
  },
  onInput: (e: any) => {
    e.target.setCustomValidity("");
  }
};

export const websiteValidator = {
  pattern:
    "^([a-zA-Z0-9:\\/-_]+)\\.([a-zA-Z0-9\\.-_]+)([\\/a-zA-Z0-9-_]*)[^\\.]$",
  onInvalid: (e: any) => {
    e.target.setCustomValidity("");
    if (!e.target.validity.valid) {
      e.target.setCustomValidity("Please enter the correct website address");
    }
  },
  onInput: (e: any) => {
    e.target.setCustomValidity("");
  }
};
